// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"StackedPill_wrapper__YUzWY","bar":"StackedPill_bar__63bis","segment":"StackedPill_segment__OxuIv","labels":"StackedPill_labels__qcdqh","label":"StackedPill_label__2bGDA"};